import { GlobalModalAndDrawerPayload } from '../types';
import { GlobalModalAndDrawer } from './GlobalModalAndDrawer';

export class GlobalModal extends GlobalModalAndDrawer {
  constructor({ name, data }: GlobalModalAndDrawerPayload) {
    super({ type: 'modal', name, data });
  }
}
